<script setup>
/**
 * FormControlFilesFileSize
 * Formats a raw byte integer into a human-readable string.
 */
import { computed } from 'vue';
import FormControlPlainText from "./FormControlPlainText.vue";

const props = defineProps({
    // Standard Orchestrator Props
    formId: {
        type: String,
        required: true
    },
    field: {
        type: Object,
        required: true
    },
    currentData: {
        type: Object,
        required: true
    },
    value: {
        type: [String, Number],
        default: null
    }
});

// --- Helpers ---

/**
 * Converts bytes to human readable format (KB, MB, GB, etc.)
 * You can move this to a /utils folder and import it instead of
 * using the legacy Mixin.
 */
const formatHumanFileSize = (bytes, si = false, dp = 1) => {
    const thresh = si ? 1000 : 1024;

    if (Math.abs(bytes) < thresh) {
        return bytes + ' B';
    }

    const units = si
        ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

    let u = -1;
    const r = 10 ** dp;

    do {
        bytes /= thresh;
        ++u;
    } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

    return bytes.toFixed(dp) + ' ' + units[u];
};

// --- Computed ---

const fileSize = computed(() => {
    const rawSize = props.currentData.fileSize;
    return rawSize ? formatHumanFileSize(rawSize) : '';
});
</script>

<template>
    <FormControlPlainText
        :value="fileSize"
        :form-id="formId"
    />
</template>